// AjlSaleContractStyled.js
import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../style/ajl-contract-styled.css";
import { toArabicWord } from "number-to-arabic-words/dist/index-node.js";

export default function AjlSaleContractStyled({ data, officeData, logo, contractHeader }) {
  function convertDateFormat(inputDate, locale) {
    const dateObject = new Date(inputDate);
    const options = { day: "2-digit", month: "2-digit", year: "numeric" };
    if (locale !== "ar-SA") {
      // Format date as YYYY-MM-DD for English locale
      const year = dateObject.getFullYear();
      const month = (dateObject.getMonth() + 1).toString().padStart(2, "0");
      const day = dateObject.getDate().toString().padStart(2, "0");
      return `${day}-${month}-${year}`;
    }

    const formattedDate = dateObject.toLocaleDateString(locale, options);
    return formattedDate;
  }
  return (
    <div className="d-flex justify-content-center py-2 bg-white" dir="rtl">
      <div className="contract-sheet bg-white">
        {!data?.for_investor && <div className="row justify-content-between">
          <div className="mb-4 px-4 col-4" dir="rlt">
            <div className="mx-1">{officeData?.branch_name}</div>
            <div className="mx-1">سجل تجاري {officeData?.valid_id_number}</div>
            <div className="mx-1">رقم الجوال {officeData?.contact_number}</div>
          </div>
          {logo && <div className="col-4 row justify-content-center">
            <img src={logo}
              style={{ width: "auto", height: "100px" }}
              alt="" />
          </div>}
          <div className="col-4">
            {contractHeader && Object.entries(contractHeader).map(([key, value], index) => (
              <div key={index}>
                {value || ""}
              </div>
            ))}
          </div>
        </div>}
        {/* Title band with L-underline */}
        <div className="title-wrap">
          <div className="doc-title">{data?.contract_type === "Future" ? "عقد بيع بالإجل" : "عقد بيع بالآجل"}</div>
        </div>

        {/* Top meta row */}
        <div className="container-fluid px-4">
          <div className="row g-2 align-items-center mt-2 date-header">
            <div className="col-4 text-end fw-semibold">
              <span>رقم العقد /</span>
              <span className="value mx-1 text-danger">
                {data?.contract_form_number}
              </span>
            </div>
            <div className="col-4 text-center fw-semibold">
              <span>أنه في يوم</span>
              <span className="value mx-2">
                {convertDateFormat(data?.date_contract, "ar-SA")}
              </span>
            </div>
            <div className="col-4 text-end fw-semibold">
              <span>الموافق </span>
              <span className="value mx-1">
                {convertDateFormat(data?.date_contract)}
              </span>
            </div>
          </div>

          {/* Preamble */}
          <div className="mt-2">
            <span>الحمد لله والصلاة والسلام على من لا نبي بعده......وبعد:</span>{" "}
            فأقر انا الموقع أدناه الطرف الثاني /{" "}
          </div>
          <span>{data?.customer_name}</span>

          {/* basic info */}
          <div className="row">
            <div className="col-4">
              تاريخ الميلاد :{" "}
              <span className="value mx-1">
                {convertDateFormat(data?.customer_DoB)}
              </span>
            </div>
            <div className="col-8">
              بطاقة أحوال رقم /
              <span className="value mx-1">{data?.customer_id}</span>
            </div>
          </div>
          <div className="row">
            <div className="col-4">
              جوال /<span className="value mx-1">{data?.customer_phone}</span>
            </div>
            <div className="col-8">
              الوظيفة/
              <span className="value mx-1">{data?.customer_occupation}</span>
            </div>
          </div>

          {/* Amount para */}
          <div>
            <div>
              وأنا بكامل الأوصاف المعتبرة شرعاً: بأنني اشتريت من الطرف الاول /
              <span className="value mx-1">{data.for_investor ? data.investor_name : officeData.branch_name}</span>
            </div>
            <div>{data?.description}</div>
            <div className="d-flex justify-content-center">
              <div>
                بمبلغ وقدره{" "}
                <span className="amount-box">( {data?.total_value} )</span>
              </div>
              <div className="d-flex justify-content-center mx-2">
                {toArabicWord(data?.total_value || 0)}
              </div>
              <span className="icon-saudi_riyal_new"></span>
            </div>
          </div>

          {/* due date */}
          <div>
            تسدد على دفعة واحدة بتاريخ :
            <span className="mx-1">
              {convertDateFormat(data?.date_1st_installment)}
            </span>
          </div>

          {/* Terms paragraph */}
          <div className="mt-2">
            هذا وقد استلمت البضاعة على حالتها الراهنة وقبلتها بعد معاينتها بما
            فيها من عيوب ظاهرة وباطنة بما ينفي الجهالة أو الغرر أو الغبن .
          </div>
          <div className="mt-2">
            وقد اتفق الطرفان في حالة تأخر المشتري عن سداد قيمة المبيع في الوقت
            المتفق عليه فإن للطرف الأول الحق بالاتجاه إلى الجهات المختصة لإقامة
            الدعوى في المحكمة المختصة بمدينة {data.judgement_city} (شرط ملزم للطرفين)
          </div>

          {/* Notes */}
          <div className="mt-2">ملاحظات : {data.notes || ""}</div>
          {data?.guarantors && (
            <>
              {/* Section title between rules */}
              <div className="section-caption mt-3">
                <span>إقرار الكفيل (الضامن)</span>
              </div>

              {/* Guarantor row */}
              <div className="row">
                <div className="col-6">
                  اقر واتعهد أنا المكرم /
                  <span className="mx-1">{data?.guarantors}</span>
                </div>
                <div className="col-6">
                  بطاقة أحوال رقم /
                  <span className="mx-1">{data?.guarantor_Vid}</span>
                </div>
              </div>
              <div className="row">
                <div className="col-4">
                  تاريخ الميلاد /
                  <span className="mx-1">{data?.guarantor_dob}</span>
                </div>
                <div className="col-4">
                  مصدرها أحوال /
                  <span className="mx-1">{data?.guarantor_idSource}</span>
                </div>
                <div className="col-4">
                  هاتف رقم /
                  <span className="mx-1">{data?.guarantor_phone}</span>
                </div>
              </div>

              {/* Payment */}
              <div className="mt-3">
                وأنا بكامل الأوصاف المعتبرة شرعاً:{" "}
                <span className="mx-1"></span>
              </div>

              <div className="mx-1">
                بأني أكفل وأضمن الطرف الثاني /
                <span className="mx-4"> {data?.customer_name} </span> وذلك
                بتسديد ودفع قيمة العقد المطلوب
              </div>

              {/* Terms after guarantor */}
              <div className="mt-2">
                للسيد /
                <span className="amount-box px-4"> {data?.customer_name} </span>
                على المذكور حسب الاتفاقية المبرمة بينهما بحيث أقوم بدفع كل قسط
                في حينه إذا تأخر مكفولي المذكور عن دفعه وألزم أيضاً ورثتي من
                بعدي في حال حدوث أمر لا سمح الله والله خير الشاهدين، وصلى الله
                على محمد صلى الله عليه وسلم.
              </div>
            </>
          )}
          {/* Witness + stamp/signatures area */}
          <div className="title-line"></div>
          <div className="row">
            <div className="col-6 text-center">
              <span className="d-inline-block dotted-underline px-4">
                الطرف الأول البائع
              </span>
            </div>
            <div className="col-6 text-center">
              <span className="d-inline-block dotted-underline px-4">
                الطرف الثاني المشتري
              </span>
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-4">
              الاســم / <span className="mx-1">{data.for_investor ? data.investor_name : officeData.branch_name}</span>
            </div>
            <div className="col-4">الختم</div>
            <div className="col-4">
              الاســم / <span className="mx-1">{data?.customer_name}</span>
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-8">التوقيع /</div>
            <div className="col-4">التوقيع /</div>
          </div>
          <div className="row mt-4">
            <div className="col-4">الشاهد الأول</div>
            <div className="col-4">{data?.guarantors && "الكفيل الغارم"}</div>
            <div className="col-4">الشاهد الثاني</div>
          </div>
          <div className="row mt-2">
            <div className="col-4">الاســم /</div>
            <div className="col-4">{data?.guarantors && "الاســم /"}</div>
            <div className="col-4">الاســم /</div>
          </div>
          <div className="row mt-2">
            <div className="col-4">التوقيع /</div>
            <div className="col-4">{data?.guarantors && "التوقيع /"}</div>
            <div className="col-4">التوقيع /</div>
          </div>

          {/* Bottom spacing */}
          <div style={{ height: 8 }} />
        </div>
      </div>
    </div>
  );
}
